const contextNotInitErrorMessage = 'ApplicationContext not init';
export class ApplicationContext {
    get wallet() {
        if (!this._wallet)
            throw new Error(contextNotInitErrorMessage);
        return this._wallet;
    }
    get tokenStorage() {
        if (!this._tokenController)
            throw new Error(contextNotInitErrorMessage);
        return this._tokenController;
    }
    get notifications() {
        if (!this._notifications)
            throw new Error(contextNotInitErrorMessage);
        return this._notifications;
    }
    get i18n() {
        if (!this._i18n)
            throw new Error(contextNotInitErrorMessage);
        return this._i18n;
    }
    get theme() {
        if (!this._theme)
            throw new Error(contextNotInitErrorMessage);
        return this._theme;
    }
    get storage() {
        if (!this._storageManager)
            throw new Error(contextNotInitErrorMessage);
        return this._storageManager;
    }
    get tokenRateProvider() {
        if (!this._tokenRateProvider)
            throw new Error(contextNotInitErrorMessage);
        return this._tokenRateProvider;
    }
    get api() {
        if (!this._api)
            throw new Error(contextNotInitErrorMessage);
        return this._api;
    }
    get logger() {
        if (!this._logger)
            throw new Error(contextNotInitErrorMessage);
        return this._logger;
    }
    get turnstile() {
        if (!this._turnstile)
            throw new Error(contextNotInitErrorMessage);
        return this._turnstile;
    }
    get onChain() {
        if (!this._chainController)
            throw new Error(contextNotInitErrorMessage);
        return this._chainController;
    }
    get settings() {
        if (!this._settings)
            throw new Error(contextNotInitErrorMessage);
        return this._settings;
    }
    get animations() {
        if (!this._animations)
            throw new Error(contextNotInitErrorMessage);
        return this._animations;
    }
    get environment() {
        if (!this._environment)
            throw new Error(contextNotInitErrorMessage);
        return this._environment;
    }
    get overlay() {
        if (!this._overlay)
            throw new Error(contextNotInitErrorMessage);
        return this._overlay;
    }
    constructor(payload, isEmbedded = false) {
        this.payload = payload;
        this.isEmbedded = isEmbedded;
        this._activeSwapContext = null;
    }
    async init() {
        const [wallet, tokenStorage, notifications, i18n, theme, storage, tokenRateProvider, api, logger, turnstile, onChain, settings, animations, environment, overlay,] = await Promise.all([
            this.payload.walletFactory(),
            this.payload.tokenControllerFactory(),
            this.payload.notificationsManagerFactory(),
            this.payload.i18nManagerFactory(),
            this.payload.themesManagerFactory(),
            this.payload.storageManagerFactory(),
            this.payload.tokenRateProviderFactory(),
            this.payload.apiFactory(),
            this.payload.loggerFactory(),
            this.payload.turnstileFactory(),
            this.payload.onChainFactory(),
            this.payload.settingsFactory(),
            this.payload.animationsFactory(),
            this.payload.environmentFactory(),
            this.payload.overlayFactory(),
        ]);
        this._wallet = wallet;
        this._tokenController = tokenStorage;
        this._notifications = notifications;
        this._i18n = i18n;
        this._theme = theme;
        this._storageManager = storage;
        this._tokenRateProvider = tokenRateProvider;
        this._api = api;
        this._logger = logger;
        this._turnstile = turnstile;
        this._chainController = onChain;
        this._settings = settings;
        this._animations = animations;
        this._environment = environment;
        this._overlay = overlay;
        await Promise.all([
            this._logger.init(this),
            this._settings.init(this),
            this._turnstile.init(this),
            this._wallet.init(this),
            this._i18n.init(this),
            this._theme.init(this),
            this._tokenController.init(this),
            this._tokenRateProvider.init(this),
            this._api.init(this),
            this._chainController.init(this),
            this._notifications.init(this),
            this._animations.init(this),
            this._overlay.init(this),
        ]);
    }
    async makeSwapContext() {
        const context = await this.payload.swapContextFactory(this);
        this._activeSwapContext = new WeakRef(context);
        return context;
    }
    getActiveSwapContext() {
        return this._activeSwapContext?.deref() ?? null;
    }
    async buildEntity(constructor) {
        const entity = isConstructor(constructor) ? new constructor() : constructor();
        await entity.init(this);
        return entity;
    }
}
function isConstructor(fn) {
    return typeof fn === 'function' && !!fn.prototype;
}
//# sourceMappingURL=application-context.js.map